<template>
  <div class="container card card-body card-full-width-mobile mt-3 mt-md-9 p-0 p-lg-8">
    <loader v-if="!iquoteId"></loader> 
    <div v-else>
      <div class="m-4">
        <h2 class="text-primary mb-lg-7">Aanbod zonnepanelen {{ company.name }}</h2>
        <p>Beste bewoner(s) van {{ address }},</p>
        <p>Met zonnepanelen wekt u zelf groene stroom op. Hierdoor hoeft u minder stroom in te kopen en gaat uw energierekening flink omlaag. 
          Zo houdt u geld over voor andere zaken én helpt u het milieu een handje!
        </p>
        <p>
          {{ company.name }} betaalt de aanschaf, de garanties, de plaatsing en het onderhoud van de zonnepanelen. De zonnepanelen komen in eigendom van {{ company.name }}. 
          Voor het gebruik van de zonnepanelen betaalt u een bijdrage per maand aan {{ company.name }}. De besparing op uw energierekening is altijd hoger dan de bijdrage die u voor de zonnepanelen gaat betalen. 
          Kortom, de zonnepanelen leveren u altijd geld op.
        </p>
        <p>Voor ieder dak maken wij met speciale software en satellietbeelden een opbrengstberekening. 
          Bekijk hieronder hoeveel stroom de zonnepanelen op uw dak gaan opwekken.
        </p>
      </div>
      <B2bSavingsCalculator
        v-if="simplifiedQuotes.length && selectedQuote"
        :simplifiedQuotes="simplifiedQuotes"
        :selectedQuote="selectedQuote"
        @selectQuote="selectQuote"></B2bSavingsCalculator>
      <div class="m-4 mt-8">
        <h2 class="text-primary">Digitaal akoord geven</h2>
      </div>
      <B2bOfferForm :selectedQuote="selectedQuote" v-if="selectedQuote"></B2bOfferForm>
      <div class="m-4 mt-8">
        <h2 class="text-primary">Wat kan ik nu verwachten?</h2>
        <p>Na acceptatie van het aanbod ontvangt u per e-mail een bevestiging van de overeenkomst.
          U heeft de mogelijkheid om deze overeenkomst binnen 14 dagen zonder opgave van reden te ontbinden.
        </p>
        <TextOnlyUnorderedList :listItems="nextStepsList"></TextOnlyUnorderedList>
        <p>
          <b>Heeft u nog vragen?</b>
          <br>
          Neem dan gerust contact met ons op. We zijn op werkdagen tussen 09:00 en 17:00 uur bereikbaar op 020 309 09 01 of via huurdak@sungevity.nl
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import B2bOfferForm from '@/components/b2b/B2bOfferForm'
import B2bSavingsCalculator from '@/components/b2b/B2bOfferSavingsCalculator'
import TextOnlyUnorderedList from '@/components/main/list/TextOnlyUnorderdedList'
import textList  from "@/components/b2b/listItems"
import { mapGetters } from 'vuex'

export default {
  name: 'B2bOffer',
  components: {
    B2bOfferForm,
    B2bSavingsCalculator,
    TextOnlyUnorderedList,
  },
  data() {
    return {
      nextStepsList: textList.nextStepsList,
      selectedQuote: '',
    }
  },
  computed: {
    ...mapGetters(['company', 'fullName', 'iquoteId', 'contact']),
    address() {
      if (!this.contact.address) return ''
      const { street, houseNumber, houseNumberAddition } = this.contact.address
      return `${street} ${houseNumber} ${houseNumberAddition || ''}`
    },
    simplifiedQuotes() {
      if (!this.quotes) return []
      const quotes = this.quotes.map(q => {
        return {
          id: q.id,
          energyGenerated: q.detailOverview.energyGenerated && q.detailOverview.energyGenerated[0],
          monthlyPayment: q.detailOverview.monthlyPayment,
          numberOfPanels: q.panels.quantity,
          termsAndConditions: q.termsAndConditions,
          energyPrice: q.detailOverview.energyPrice,
        }
      })

      return quotes.sort((a, b) => {
        if (a.numberOfPanels > b.numberOfPanels) {
          return -1
        }
        if (a.numberOfPanels < b.numberOfPanels) {
          return 1
        }
        return 0
      })
    }
  },
  methods: {
    selectQuote(quote) {
      this.selectedQuote = quote
    },
  },
  mounted() { 
    this.selectedQuote = this.simplifiedQuotes[0]
  }
}
</script>
